/* Drowsie page editor — MN's review overlay.
   Activate on any page that includes this script by adding ?edit=1 to the URL.
   ✎  tap any text and retype it in place
   💬 tap any element and leave a comment
   Send → rows land in ops_notes (ns "pedit-<page>") via the public chat-notes fn;
   Claude lists them with ops-notes {op:"list"} and applies them to the template.
*/
(function () {
  var qs = new URLSearchParams(location.search);
  if (qs.get('edit') !== '1') return;

  var PAGE = location.pathname.replace(/^\/+|\/+$/g, '').replace(/[^a-z0-9-]+/gi, '-').toLowerCase() || 'home';
  var NS = ('pedit-' + PAGE).slice(0, 64);
  var LSKEY = 'drw_pedit:' + PAGE;
  var FN = 'https://ewiyzrpflyuwhiwedxnp.supabase.co/functions/v1/chat-notes';
  var EDITABLE = 'P,H1,H2,H3,H4,H5,H6,LI,SPAN,B,I,EM,STRONG,A,BUTTON,FIGCAPTION,SMALL,TD,TH,BLOCKQUOTE,DT,DD,LABEL'.split(',');

  var queue = [];
  try { queue = JSON.parse(localStorage.getItem(LSKEY) || '[]'); } catch (e) {}
  var mode = null; // 'edit' | 'comment' | null
  var editingEl = null;

  /* ---------- selector for an element ---------- */
  function selOf(el) {
    if (el.id) return '#' + el.id;
    var path = [], n = el, depth = 0;
    while (n && n.nodeType === 1 && depth < 6 && n.tagName !== 'BODY') {
      var tag = n.tagName.toLowerCase(), part = tag;
      if (n.id) { path.unshift('#' + n.id); break; }
      var sibs = Array.prototype.filter.call(n.parentNode ? n.parentNode.children : [], function (c) { return c.tagName === n.tagName; });
      if (sibs.length > 1) part += ':nth-of-type(' + (sibs.indexOf(n) + 1) + ')';
      path.unshift(part); n = n.parentNode; depth++;
    }
    return path.join(' > ');
  }
  function snippet(el) { return (el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 140); }

  /* ---------- styles ---------- */
  var css = document.createElement('style');
  css.textContent =
    '.pe-bar{position:fixed;right:12px;bottom:12px;z-index:2147483000;display:flex;flex-direction:column;gap:8px;align-items:flex-end;font-family:-apple-system,sans-serif}' +
    '.pe-btn{border:0;border-radius:999px;padding:0;width:52px;height:52px;font-size:1.25rem;background:#3B2246;color:#F3EBE5;box-shadow:0 8px 24px rgba(0,0,0,.35);cursor:pointer;position:relative}' +
    '.pe-btn.on{background:#C9A24A;color:#241A2E;outline:3px solid rgba(201,162,74,.35)}' +
    '.pe-btn.send{width:auto;padding:0 20px;height:52px;font-size:.85rem;font-weight:800;letter-spacing:.06em;background:#1E7B45;display:none}' +
    '.pe-btn.send.has{display:block}' +
    '.pe-badge{position:absolute;top:-4px;right:-4px;background:#B0323C;color:#fff;border-radius:999px;min-width:20px;height:20px;line-height:20px;font-size:.68rem;font-weight:800;text-align:center;padding:0 4px}' +
    '.pe-hint{position:fixed;left:12px;right:76px;bottom:12px;z-index:2147483000;background:rgba(36,26,46,.94);color:#F3EBE5;border-radius:12px;padding:10px 14px;font:600 .8rem/1.4 -apple-system,sans-serif;display:none}' +
    '.pe-hint.on{display:block}' +
    '.pe-edited{outline:2px solid #C9A24A !important;outline-offset:2px}' +
    '.pe-commented{outline:2px dashed #B0538D !important;outline-offset:2px}' +
    '.pe-target{outline:2px solid #3897F0 !important;outline-offset:2px}' +
    '.pe-panel{position:fixed;left:12px;right:12px;bottom:76px;z-index:2147483001;background:#FBF6EF;border-radius:14px;box-shadow:0 18px 50px rgba(0,0,0,.4);padding:14px;font-family:-apple-system,sans-serif;display:none}' +
    '.pe-panel.on{display:block}' +
    '.pe-panel .t{font-size:.72rem;color:#6A5B76;margin-bottom:8px;line-height:1.4}' +
    '.pe-panel textarea{width:100%;min-height:84px;border:1px solid rgba(59,34,70,.25);border-radius:10px;padding:10px;font:400 1rem/1.4 -apple-system,sans-serif;box-sizing:border-box}' +
    '.pe-panel .row{display:flex;gap:8px;margin-top:10px}' +
    '.pe-panel .row button{flex:1;border:0;border-radius:999px;padding:13px;font-weight:800;font-size:.82rem;cursor:pointer}' +
    '.pe-save{background:#3B2246;color:#F3EBE5}.pe-cancel{background:#E8E0D8;color:#241A2E}' +
    '.pe-toast{position:fixed;left:50%;transform:translateX(-50%);bottom:140px;z-index:2147483002;background:#1E7B45;color:#fff;border-radius:999px;padding:12px 22px;font:700 .85rem -apple-system,sans-serif;box-shadow:0 10px 30px rgba(0,0,0,.35)}';
  document.head.appendChild(css);

  /* ---------- toolbar ---------- */
  var bar = document.createElement('div'); bar.className = 'pe-bar';
  bar.innerHTML =
    '<button class="pe-btn send" id="peSend">Send</button>' +
    '<button class="pe-btn" id="peEdit" title="Edit text">✎</button>' +
    '<button class="pe-btn" id="peComment" title="Comment">💬</button>' +
    '<button class="pe-btn" id="peOff" title="Exit" style="background:#5A4A66">✕</button>';
  document.body.appendChild(bar);
  var hint = document.createElement('div'); hint.className = 'pe-hint'; document.body.appendChild(hint);
  var panel = document.createElement('div'); panel.className = 'pe-panel';
  panel.innerHTML = '<div class="t" id="pePanelT"></div><textarea id="pePanelTa" placeholder="Tell Claude what to change here…"></textarea><div class="row"><button class="pe-cancel" id="pePanelX">Cancel</button><button class="pe-save" id="pePanelOk">Save comment</button></div>';
  document.body.appendChild(panel);
  var commentTarget = null;

  function refresh() {
    var s = document.getElementById('peSend');
    s.className = 'pe-btn send' + (queue.length ? ' has' : '');
    s.innerHTML = 'Send ' + queue.length + ' to Claude →';
    document.getElementById('peEdit').className = 'pe-btn' + (mode === 'edit' ? ' on' : '');
    document.getElementById('peComment').className = 'pe-btn' + (mode === 'comment' ? ' on' : '');
    hint.className = 'pe-hint' + (mode ? ' on' : '');
    hint.textContent = mode === 'edit' ? 'EDIT MODE — tap any text, retype it, tap elsewhere to keep it.' :
                       mode === 'comment' ? 'COMMENT MODE — tap the thing you want to talk about.' : '';
    try { localStorage.setItem(LSKEY, JSON.stringify(queue)); } catch (e) {}
  }
  function toast(msg, ms) {
    var t = document.createElement('div'); t.className = 'pe-toast'; t.textContent = msg;
    document.body.appendChild(t); setTimeout(function () { t.remove(); }, ms || 2600);
  }
  function push(item) { queue.push(item); refresh(); }

  /* ---------- edit mode ---------- */
  function finishEdit() {
    if (!editingEl) return;
    var el = editingEl; editingEl = null;
    el.contentEditable = 'false'; el.classList.remove('pe-target');
    var before = el.getAttribute('data-pe-before') || '';
    var after = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (after !== before.replace(/\s+/g, ' ').trim()) {
      el.classList.add('pe-edited');
      push({ type: 'edit', sel: selOf(el), before: before.replace(/\s+/g, ' ').trim().slice(0, 600), after: after.slice(0, 600) });
    }
  }
  function beginEdit(el) {
    finishEdit();
    editingEl = el;
    if (!el.getAttribute('data-pe-before')) el.setAttribute('data-pe-before', el.textContent || '');
    el.contentEditable = 'true'; el.classList.add('pe-target'); el.focus();
  }

  /* ---------- global tap handling ---------- */
  document.addEventListener('click', function (e) {
    if (!mode) return;
    if (bar.contains(e.target) || panel.contains(e.target)) return;
    e.preventDefault(); e.stopPropagation();
    var el = e.target.closest(EDITABLE.join(','));
    if (mode === 'edit') {
      if (!el) { finishEdit(); return; }
      if (el === editingEl) return;
      beginEdit(el);
    } else if (mode === 'comment') {
      commentTarget = el || e.target;
      document.getElementById('pePanelT').textContent = 'Commenting on: “' + snippet(commentTarget).slice(0, 90) + '”';
      document.getElementById('pePanelTa').value = '';
      panel.className = 'pe-panel on';
      document.getElementById('pePanelTa').focus();
    }
  }, true);

  document.getElementById('peEdit').addEventListener('click', function () { finishEdit(); mode = (mode === 'edit' ? null : 'edit'); refresh(); });
  document.getElementById('peComment').addEventListener('click', function () { finishEdit(); mode = (mode === 'comment' ? null : 'comment'); refresh(); });
  document.getElementById('peOff').addEventListener('click', function () {
    finishEdit(); mode = null; refresh();
    if (!queue.length || confirm('Leave edit mode? ' + queue.length + ' unsent change(s) stay saved on this phone.')) {
      qs.delete('edit'); location.search = qs.toString();
    }
  });
  document.getElementById('pePanelX').addEventListener('click', function () { panel.className = 'pe-panel'; });
  document.getElementById('pePanelOk').addEventListener('click', function () {
    var txt = document.getElementById('pePanelTa').value.trim();
    if (txt && commentTarget) {
      commentTarget.classList.add('pe-commented');
      push({ type: 'comment', sel: selOf(commentTarget), snippet: snippet(commentTarget), comment: txt.slice(0, 2000) });
    }
    panel.className = 'pe-panel';
  });

  /* ---------- send ---------- */
  document.getElementById('peSend').addEventListener('click', function () {
    finishEdit();
    if (!queue.length) return;
    var items = queue.slice(), sent = 0, btn = this;
    btn.disabled = true; btn.innerHTML = 'Sending…';
    (function next() {
      if (!items.length) {
        queue = []; refresh(); btn.disabled = false;
        toast('Sent ' + sent + ' to Claude ✓ — they\'ll be applied to the page source.');
        return;
      }
      var it = items.shift();
      fetch(FN, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
        body: JSON.stringify({
          ns: NS, screen: it.type,
          note: it.type === 'edit' ? ('EDIT: "' + it.before.slice(0, 80) + '" → "' + it.after.slice(0, 80) + '"') : ('COMMENT: ' + it.comment.slice(0, 160)),
          answers: it, url: location.href, ua: navigator.userAgent.slice(0, 120)
        })
      }).then(function () { sent++; setTimeout(next, 450); })
        .catch(function () { setTimeout(next, 900); });
    })();
  });

  refresh();
  toast('Review mode on — ✎ edit text · 💬 comment', 3200);
})();
